var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navigation'),_c('div',{class:{
      'side-margin': _vm.$vuetify.breakpoint.mdAndUp,
      'bottom-margin': _vm.$vuetify.breakpoint.smAndDown,
      'pa-4': true,
      'py-md-8': true,
      'px-md-16': true,
    }},[_c('router-view',{key:_vm.$route.path})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }